export const useToastNotification = () => {
  const toast = useToast();

  return {
    success: (title: string, description: string | null = null) => {
      toast.add({
        title,
        description: description ?? "",
        icon: "i-heroicons-check-circle",
        color: "green",
      });
    },

    error: (title: string, description: string | null = null) => {
      toast.add({
        title,
        description: description ?? "",
        icon: "i-heroicons-exclamation-triangle",
        color: "red",
      });
    },
  };
};
